


































import vExpertApply from 'components/expertApply/index.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    vExpertApply
  }
})
export default class VSuspension extends Vue {
  isShowTutor: boolean = false;
  isShowContact: boolean = false;
  isShowExpertApply: boolean = false;
}
